"use strict";

import http from "@/http";

const BASE_NAME = "/vehicle-type";

const list = async () => {
  const response = await http.get(`${BASE_NAME}`);
  return response.data;
};

const create = async data => {
  const response = await http.post(`${BASE_NAME}`, data);
  return response.data;
};

const edit = async obligation => {
  const response = await http.put(`${BASE_NAME}/${obligation._id}`, obligation);
  return response.data;
};

const remove = async id => {
  const response = await http.delete(`${BASE_NAME}/${id}`);
  return response.data;
};

const getObligations = async () => {
  const response = await http.get(`${BASE_NAME}/obligations`);
  return response.data;
};

export default {
  list,
  create,
  edit,
  remove,
  getObligations
};
